import { useCallback, useEffect, useState } from "react"
import { createUser } from "../../services/userApis"
import Input from "../Input"
import MyModal from "../MyModal"
import { toast } from "react-toastify"
import { useSocket, useSocketEvent } from "../../contexts/SocketContext"

const CreateUserModal = ({ userList, isOpen, toggleModal }) => {
    const { isConnected, sendMessage } = useSocket()

    const [usernameIsValid, setUsernameIsValid] = useState(false)
    const [companyList, setCompanyList] = useState(null)

    const handleCompanyList = useCallback((data) => {
        setCompanyList(data)
    }, [])

    useSocketEvent("companyList", handleCompanyList)

    const handleSubmit = (e) => {
        e.preventDefault()
        if (!usernameIsValid) {
            toast.error("نام کاربری معتبر نمیباشد")
            return
        }
        toggleModal()

        const form = new FormData(e.target)
        const username = form.get("username")
        const password = form.get("password")
        const scope = form.get("scope")
        const initialBalance = form.get("initial-balance")
        const companyName = form.get("company-name")
        const info = form.get("info")
        const canUseBot = form.get("can-use-bot") == "on" ? true : false
        const canUseManagerBot = form.get("can-use-manager-bot") == "on" ? true : false
        const canUseServers = form.get("can-use-servers") == "on" ? true : false
        const canUseRanksystems = form.get("can-use-ranksystems") == "on" ? true : false

        const data = {
            username,
            password,
            scope,
            info,
            initialBalance,
            companyName,
            canUseBot,
            canUseManagerBot,
            canUseServers,
            canUseRanksystems,
        }

        toast.promise(createUser(data), {
            pending: "درحال ساخت کاربر",
            success: "کاربر با موفقیت ساخته شد",
        })
    }

    useEffect(() => {
        if (isOpen && isConnected) {
            sendMessage("getCompanyList")
        }
    }, [isOpen, isConnected])

    const handleUsernameOnChange = (event) => {
        var usernameLabel = document.getElementById("usernameLabel")
        var username = event.target.value
        const usedUser = userList.find((item) => item.username === username)
        if (usedUser || username == "") {
            setUsernameIsValid(false)
            usernameLabel.innerHTML = '<div class="show_info text-sm text-red-400">نامعتبر</div>'
        } else {
            setUsernameIsValid(true)
            usernameLabel.innerHTML = '<div class="show_info text-sm text-green-400">معتبر</div>'
        }
    }

    return (
        <MyModal isOpen={isOpen} toggleModal={toggleModal} width="400px" height="500px">
            <div className="">
                <form onSubmit={handleSubmit} className="m-2 ml-2">
                    <div className="mt-2 grid grid-cols-2 gap-x-5">
                        <Input
                            type="text"
                            dir="ltr"
                            label={"نام کاربری"}
                            placeholder={"نام کاربری"}
                            name={"username"}
                            onChange={handleUsernameOnChange}
                            required={true}
                        />

                        <Input
                            type="password"
                            dir="ltr"
                            label={"پسورد"}
                            placeholder={"پسورد"}
                            name={"password"}
                            required={true}
                        />
                        <span id="usernameLabel">
                            <div class="show_info text-sm text-green-400">معتبر</div>
                        </span>
                    </div>
                    <div>
                        <div className="mt-2">
                            <label className="block">پکیج ها</label>
                            <select class="styled-select" name="scope">
                                <option value="admin">ادمین</option>
                                <option value="reseller">نماینده</option>
                            </select>
                        </div>
                        <Input
                            type="number"
                            dir="ltr"
                            label={"موجودی اولیه"}
                            placeholder={"موجودی اولیه"}
                            name={"initial-balance"}
                            defaultValue={0}
                            required={true}
                        />
                    </div>
                    <div>
                        <label className="block">اسم کمپانی</label>
                        <select class="styled-select" name="company-name">
                            {companyList &&
                                companyList.map((item, index) => (
                                    <option key={index} value={item.name}>
                                        {item.name}
                                    </option>
                                ))}
                        </select>
                    </div>

                    <div className="mt-2">
                        <Input type="text" dir="rtl" label={"توضیحات"} placeholder={"توضیحات"} name={"info"} />
                    </div>
                    <div className="flex my-1" dir="rtl">
                        ساخت تیم اسپیک: &nbsp;
                        <span class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">غیرفعال</span>
                        <label class="relative inline-flex items-center cursor-pointer">
                            <input type="checkbox" name="can-use-servers" class="sr-only peer" />
                            <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none  peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                            <span class="mr-2 text-sm font-medium text-gray-900 dark:text-gray-300">فعال</span>
                        </label>
                    </div>
                    <div className="flex my-1" dir="rtl">
                        ساخت بات موزیک: &nbsp;
                        <span class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">غیرفعال</span>
                        <label class="relative inline-flex items-center cursor-pointer">
                            <input type="checkbox" name="can-use-bot" class="sr-only peer" />
                            <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none  peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                            <span class="mr-2 text-sm font-medium text-gray-900 dark:text-gray-300">فعال</span>
                        </label>
                    </div>
                    <div className="flex my-1" dir="rtl">
                        ساخت بات مدیریتی: &nbsp;
                        <span class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">غیرفعال</span>
                        <label class="relative inline-flex items-center cursor-pointer">
                            <input type="checkbox" name="can-use-manager-bot" class="sr-only peer" />
                            <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none  peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                            <span class="mr-2 text-sm font-medium text-gray-900 dark:text-gray-300">فعال</span>
                        </label>
                    </div>
                    <div className="flex my-1" dir="rtl">
                        ساخت رنک سیستم: &nbsp;
                        <span class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">غیرفعال</span>
                        <label class="relative inline-flex items-center cursor-pointer">
                            <input type="checkbox" name="can-use-ranksystems" class="sr-only peer" />
                            <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none  peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                            <span class="mr-2 text-sm font-medium text-gray-900 dark:text-gray-300">فعال</span>
                        </label>
                    </div>

                    <button type="submit" className="styled-button w-full">
                        ساخت کاربر
                    </button>
                </form>
            </div>
        </MyModal>
    )
}

export default CreateUserModal
